<template>
  <cardTemplate :classCustom="'detail margin-top-10 margin-bottom-10 docin'">
    <template #content>
      <div class="header flex-row flex__left">
        <div class="margin-right-10">
          <img src="../../assets/img/docIn.svg" class="clickable" @click="$emit('viewMore')"/>
        </div>
        <div class="rightSection width__100 padding-bottom-10 has-border__bottom">
          <h3 class="tt1 clickable" @click="$emit('viewMore')">{{cardTitle}}</h3>
          <span class="tt2">
            <span class="font-size__small">{{docsCount || 0}} văn bản</span>
            <!--<el-tag
              type="success"
              class="priority"
              size="mini"
            >{{unreadDocCount || 0}} mới</el-tag>-->
          </span>
        </div>
      </div>
      <div class="body margin-bottom-10 margin-top-10">
        <VuePerfectScrollbar
          class="scroll-body"
          :settings="perfectScrollbarSetting"
        >
          <div v-if="docs && docs.length">
            <div
              v-for="item in docs"
              :key="item.id"
              class="file-item flex-row flex-left margin-bottom-10 clickable"
              @click="itemClick(item)"
            >
              <i class="far fa-file color__link font-size__small margin-bottom-10 margin-right-10"></i>
              <span class="file-name has-border__bottom padding-bottom-10">{{item.quote}}</span>
            </div>
          </div>
          <div v-else class="stateEmpty flex-col flex__center">
            <img
              src="../../assets/img/nothing.jpg"
              class="icon-not-found margin-bottom-10 margin-top-10"
            />
            <span class="font-size__small font-weight__bold opacity-50">Không có dữ liệu</span>
          </div>
        </VuePerfectScrollbar>
        <div class="more clickable txt-center" @click="$emit('viewMore')">XEM THÊM</div>
      </div>
    </template>
  </cardTemplate>
</template>
<script>

  export default {
    name: 'IncomingDocsCard',
    props: ["cardTitle", "docs", "docsCount", "unreadDocCount"],
    components: {
      cardTemplate: () => import('../common/cardTemplate.vue'),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    },
    data() {
      return {
        perfectScrollbarSetting: {maxScrollbarLength: 350},
      }
    },
    methods: {
      itemClick(item) {
        this.$emit("viewDetail", {doc: item});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/dashboard/ChoTiepNhanCard.vue